<template lang="pug">
.losstimeContainer
  section.hero.is-primary.is-bold
    .hero-body
      .container
        h1.title LOSSTIME
        h2.subtitle Remember that time is money.
  .losstimeMainContainer
    .losstimeConttentsContainer
      h2.contentTitle About "LOSSTI.ME"
      p.description "LOSSTI.ME" is a service for calculating the remaining time based on the "average life span of each country" and "your birthday". By subtracting sleeping time, work, bath time, etc., it is also possible to derive a more realistic remaining time.
    .losstimeConttentsContainer
      h2.contentTitle Get rough results.
      section
        h3.contentInnerTitle Select a Country 
        b-field
          b-radio-button(v-model="country" native-value="JP" type="is-primary")
            span JP
          b-radio-button(v-model="country" native-value="US" type="is-primary")
            span US 
          b-radio-button(v-model="country" native-value="IN" type="is-primary")
            span IN
          b-radio-button(v-model="country" native-value="KR" type="is-primary")
            span KR
          b-radio-button(v-model="country" native-value="CN" type="is-primary")
            span CN
          b-radio-button(v-model="country" native-value="RU" type="is-primary")
            span RU
          b-radio-button(v-model="country" native-value="SG" type="is-primary")
            span SG            
        h3.contentInnerTitle Select a Gender(optional)
        b-field
          b-radio-button(v-model="gender" native-value="male" type="is-primary")
            span Male
          b-radio-button(v-model="gender" native-value="female" type="is-primary")
            span Female 
          b-radio-button(v-model="gender" native-value="yeah" type="is-primary")
            span Yeah 
        h3.contentInnerTitle Select a Birthday
        .field.has-addons
          .control.cal
            b-datepicker(placeholder="Click to select..." icon="calendar-today" @input="registBirthday($event)" :mobile-native="false")
          .control
            button.button.is-primary(@click="getRoughResult") Caluclate
        h3.contentInnerTitle(v-if="RoughResult.elapsedDay && RoughResult.elapsedYear") Result 
        table.table.is-bordered.is-striped.result(v-if="RoughResult.elapsedDay && RoughResult.elapsedYear")
          tr
            th Elapsed years
            td {{RoughResult.elapsedYear}} Y
          tr
            th Elapsed days
            td {{RoughResult.elapsedDay}} D
          tr
            th Remaining year 
            td {{(RoughResult.remainDate / 365).toFixed(3)}} Y
          tr
            th Remaining days
            td {{RoughResult.remainDate}} D
          tr
            th Country
            td {{country}}
          tr
            th Ratio (Elapse / Remain)
            td {{((RoughResult.elapsedDay / (RoughResult.remainDate + RoughResult.elapsedDay)*100)).toFixed(3)}} %


        h3.contentInnerTitle.countdown(v-if="displayCountDown.length > 0 && displayCountDown.indexOf('great!') != -1") Great !
        h3.contentInnerTitle.countdown(v-else-if="displayCountDown") Count Down !
        .coutDownWrap(v-if="displayCountDown") {{displayCountDown}}

    .losstimeConttentsContainer
      h2.contentTitle Average life expectancy
      // http://worldpopulationreview.com/countries/life-expectancy/
      table.table.is-bordered.is-striped.ale
        thead
          tr
            th Country
            th Male
            th Female
            th Total
        tbody
          tr(v-for="record in averageLifeExpectancy")
            td {{record.name}}
            td {{record.male.year.toFixed(3)}} 
            td {{record.female.year.toFixed(3)}} 
            td {{record.total.year.toFixed(3)}}

    .losstimeConttentsContainer
      h2.contentTitle Average non-free time in Japan
      table.table.is-bordered.is-striped.ale
        thead
          tr
            th Topic
            th Average
            th Roughly annualized
        tbody
          tr
            td Sleep
            td 7h22m
            td: b 112d/y
          tr
            td Work
            td 8h+1h+1h (work + break + Commute)
            td: b 102d/y (Holiday Avg: 120D)
          tr
            td Bath
            td 20min
            td: b 5d/y
          tr
            td Meal(All)
            td 1h (20min * 3)
            td: b 15d/y
          tr
            td Smart Phone
            td 2h 
            td: b 30d/y
          tr
            td Washing
            td 15min
            td: b 3.8d/y
          tr
            td Clean up 
            td 20min
            td: b 5d/y

      p.ques: b How much more free time is there in your remaining life?

    .losstimeConttentsContainer
      h2.contentTitle The number of times of life
      table.table.is-bordered.is-striped.ale
        thead
          tr
            th The number of times of life
        tbody
          tr
            td 1 times

  h2.contentTitle.maxim I'll put here some medicines that can make you feel good.
  .maximContainer
    section.hero.is-dark
      .hero-body
        .container
          h1.title Only put off until tomorrow what you are willing to die having left undone.
          h2.subtitle Pablo Picasso

    section.hero.is-light
      .hero-body
        .container
          h1.title If you can dream it, you can do it.
          h2.subtitle Walt Disney

    section.hero.is-dark
      .hero-body
        .container
          h1.title He who is no courageous enough to take risks will accomplish nothing in life.
          h2.subtitle Muhammad Ali

    section.hero.is-light
      .hero-body
        .container
          h1.title It is never too late to become what you might have been.
          h2.subtitle George Eliot
  Habits
</template>

<script>
// @ is an alias to /src
const moment = require('moment')
const countdown = require('countdown')
import Habits from "@/components/Habits.vue"
export default {
  name: 'home',
  components: {
    Habits
  },
  data(){
    return {
      timerId: '', 
      country: '',
      birthday: '',
      timeRemaining: '',
      gender: '',
      countDownDisplayString: '',
      RoughResult: {
        now: null,
        elapsedYear: null,
        elapsedDay: null,
        gender: null,
        targetCountry: null,
        tagetDate: null,
        remainDate: null,
        countDownStartDate: null,
      },
      averageLifeExpectancy: [
        {
          name: 'Japan',
          alias: 'JP',
          male: {
            year: 80.87,
            date: 0 
          },
          female: {
            year: 87.322,
            date: 0 
          },
          total: {
            year: 0,
            date: 0
          },
        },
        {
          name: 'United States',
          alias: 'US',
          male: {
            year: 77.52 ,
            date: 0 
          },
          female: {
            year: 82.00,
            date: 0 
          },
          total: {
            year: 0,
            date: 0
          },
        },
        {
          name: 'India',
          alias: 'IN',
          male: {
            year: 67.62,
            date: 0 
          },
          female: {
            year: 70.76,
            date: 0 
          },
          total: {
            year: 0,
            date: 0
          },
        },
        {
          name: 'South Korea',
          alias: 'KR',
          male: {
            year: 79.54,
            date: 0 
          },
          female: {
            year: 85.52,
            date: 0 
          },
          total: {
            year: 0,
            date: 0
          },
        },
        {
          name: 'China',
          alias: 'CN',
          male: {
            year: 75.16,
            date: 0 
          },
          female: {
            year: 78.23,
            date: 0 
          },
          total: {
            year: 0,
            date: 0
          },
        },
        {
          name: 'Russia',
          alias: 'RU',
          male: {
            year: 65.774,
            date: 0 
          },
          female: {
            year: 76.912,
            date: 0 
          },
          total: {
            year: 0,
            date: 0
          },
        },
        {
          name: 'Singapore',
          alias: 'SG',
          male: {
            year: 81.444,
            date: 0 
          },
          female: {
            year: 85.404,
            date: 0 
          },
          total: {
            year: 0,
            date: 0
          },
        }, 
      ]
    }
  },
  methods: {
    registBirthday(value){
      this.birthday = value
    },
    async getRoughResult(){

      if(this.timerId){
        window.clearInterval(this.timerId)
        this.timerId = ''
      }

      if(!this.birthday){
        // 日付を入力してください、的なの
        return;
      }
      if(!this.country){
        // 国を選択してください、的なの
        return;
      }
      if(this.birthday && this.country){
        // uuid 生成
        // vuex 保存
        // moment で残り時間を算出
          // 誕生日 - 現在時刻　=> 年齢

        // 現在時刻
        this.RoughResult.now = moment()
        // 誕生日から現在までの経過年数
        this.RoughResult.elapsedYear = this.RoughResult.now.diff(this.birthday, 'years') 
        // 誕生日から現在までの経過日数
        this.RoughResult.elapsedDay = this.RoughResult.now.diff(this.birthday, 'days')
        // 指定性別
        this.RoughResult.gender = this.gender === "year" || "" ? "total" : this.gender
        // 国を特定し対象データを抽出
        this.RoughResult.targetCountry = this.averageLifeExpectancy.find( (ele, idx, arr) => {
          return ele.alias === this.country
        })
        // 国データから性別を指定し、{year, date} を抽出
        this.RoughResult.tagetDate = this.RoughResult.targetCountry[this.RoughResult.gender]
        // 平均寿命 - 経過日数を算出
        this.RoughResult.remainDate = this.RoughResult.tagetDate.date - this.RoughResult.elapsedDay 

        if(this.RoughResult.remainDate >= 0){
          // 現在の時間に残りの Remain Days （残り日数）を足し、カウントダウン開始時間を設定
          this.RoughResult.countDownStartDate = moment().add(this.RoughResult.remainDate, 'days')
          this.callCountDown()
        }else{
          this.countDown = "You live longer than the life expectancy of your country. That's great!"
        }
        // より詳しく計算させる画面へのリンクを表示
      }
    },
    callCountDown(){
      const self = this
      this.timerId = countdown(
        this.RoughResult.countDownStartDate,
        function(ts) {
          self.countDownDisplayString = ts
        },
        countdown.YEARS | countdown.MONTHS | countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS | countdown.MILLISECONDS
      );
    }
  },
  computed: {
    displayCountDown(){
      return this.countDownDisplayString
    }
  },
  created(){
    this.averageLifeExpectancy.forEach( (ele, idx, arr) => {
      let integer = Math.floor(ele.male.year) 
      let decimal = ele.male.year - integer
      let date = Math.round(decimal * 365)
      arr[idx].male.date = (365 * integer) + date

      integer = Math.floor(ele.female.year) 
      decimal = ele.female.year - integer
      date = Math.round(decimal * 365)
      arr[idx].female.date = (365 * integer) + date

      let avg_integer = Math.floor((ele.female.year + ele.male.year)/2)
      arr[idx].total.year = (ele.female.year + ele.male.year)/2 
      let avg_decimal = ((ele.female.year + ele.male.year)/2) - avg_integer
      let total_date = Math.round(avg_decimal * 365)
      arr[idx].total.date = (365 * avg_integer) + total_date
    })

    console.log(this.averageLifeExpectancy)
  }
}
</script>

<style lang="stylus" scoped>
.losstimeContainer
  width: 100%
  padding-bottom: 90px
  margin-top: 55px
  .contentTitle
    font-size: 1.4rem
    line-height: 2em
    font-weight: bolder
    color: #1b46a8
    &.maxim
      margin-top: 100px
      padding: 1em
  .losstimeMainContainer
    width: 90%
    margin: 0 auto
    .losstimeConttentsContainer
      margin-top: 40px
      .table.ale
        margin-top: 10px
        width: 100%
      .table.result
        width: 100%
        td
          text-align: right!important
      .contentInnerTitle
        font-weight: bolder
        font-size: 0.9rem
        line-height: 2em
        &.countdown
          font-size: 1rem
          color: #1b46a8
      .coutDownWrap
        width: 100%
        padding: 10px 13px
        background-color: #1b46a8
        color: #FFF
      .ques
        font-size: 1.2rem
        text-align: center
        line-height: 2em
</style>